module.exports = __webpack_public_path__ + "img/map-2-f.f02cb787.png";